// extracted by mini-css-extract-plugin
export default {"wrap":"Support_wrap__hmLvx"};